import React from "react";
import { useNavigate } from "react-router-dom";

export default function StepSuccess({ driver }) {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded shadow text-center">
      <h2 className="text-2xl font-semibold text-green-600 mb-4">
        ✅ Details and Docs Submitted Successfully. Thank You!
      </h2>
    </div>
  );
}
